import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconLockComponent } from "./med-icon-lock.component";

@NgModule({
  declarations: [
    MedIconLockComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconLockComponent,
  ],
})
export class MedIconLockModule { }
